module Meevo.Plugins.AppointmentBook {
  class CustomDataSummaryController extends Meevo.Components.Controls.ModalContextController {

    static $inject = [
      "context",
      "$mdDialog",
      "meevo.components.common.DataService"
    ];

    data: any[] = [];

    constructor(
      protected context: any,
      protected $mdDialog: angular.material.IDialogService,
      protected dataService: Meevo.Components.BaseClasses.IDataService) {
      super(context, $mdDialog);
      this.getAppointmentServiceAnswerData()
    }

    private getAppointmentServiceAnswerData() {
      // Build list that determine calls to retrieve custom data answer
      let appAreaList = [Model.AppAreaEnum.Booking];
      if (this.context.details.transitionState === 164)
        appAreaList.push(Model.AppAreaEnum.Checkin);
      if (this.context.details.finalState === 2051)
        appAreaList.push(Model.AppAreaEnum.Checkout);
      
      // Request appointment service answers for each identified app area
      const uri = 'api/CustomData/ApptServiceAnswer/List';
      _.forEach(appAreaList, a => {
        let criteria = {
          apptServiceList: [
            {
              serviceId: this.context.details.serviceId,
              entityId: a === Model.AppAreaEnum.Checkout ? this.context.details.saleLineId : this.context.details.id
            }
          ],
          appAreaEnum: a
        };
        // Execute requests
        this.dataService.customMethodData(uri, 'POST', { criteria })
          .then((response) => {
              var customControls = _.pluck(response.data, "control");
                if (customControls.length > 0) {
                    // Merge in existing answers if they exist
                    if (this.context.details.customControlsAnswers) {
                        customControls.forEach((customControl) => {
                            customControl.answers = _.where(this.context.details.customControlsAnswers.answers,
                                { "control_TId": customControl.control_TId });
                        });
                    }
                    // Add controls
                    let control = {
                        customControls: customControls,
                        model: { answers: [] },
                        appointDetail: this.context.details,
                        appArea: customControls ? _.first(customControls).appAreaEnum : null
                    };
                    this.data.push(control);
                    this.data = _.sortBy(this.data,
                        (c: any) => { return c.appArea === 2229 ? 1 : (c.appArea === 2409 ? 2 : 3) });
                }
            });
      });
    }

    getHeaderText(appointDetail) {
      var serviceDisplayName = appointDetail.service
        ? appointDetail.service.displayName
        : appointDetail.serviceDisplayName;
      var text = serviceDisplayName + " " + (appointDetail.startDateTime ? moment(appointDetail.startDateTime).format("h:mm a") : "");
      return `${text}`;
    }
  }

  angular.module("ApptBookApp")
    .controller("meevo.plugins.appointmentbook.CustomDataSummaryController", CustomDataSummaryController);
}